// generated from 94 samples

import { z } from "zod";
import { common } from "../common";

export const interactedWithCardTriggerGetSchema = z.object({
  event_type: z.literal("TrackedUserBehavior::InteractedWithCard"),
  card_list: z.array(
    z.object({
      id: common.objectId,
      value: z.string(),
    })
  ),
  // null: 2 (2.13%)
  interaction: z
    .enum([
      "vc", // 57 (61.96%)
      "cc", // 35 (38.04%)
    ])
    .nullable(),
  // null: 10 (10.64%)
  selected_card_id: common.objectId.nullable(),
  // null: 33 (35.11%)
  selected_card_value: z.string().nullable().optional(),
});
